module.exports = __webpack_public_path__ + "img/youtube-white.fe8eef8a.svg";